/* eslint-disable @typescript-eslint/no-non-null-assertion */
import all from '@/data/all'
import product from '@/data/product'
import { FORMATTED_PRODUCT_SERIE } from '@/data/series'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { parseJSON } from './useProductStore'
import { isAsciiOrExtended } from '@/utils'

export const useSeriesStore = defineStore('series', () => {
  const selectedSerialProduct = ref<FORMATTED_PRODUCT_SERIE>()

  const selectedSerie = computed(() => {
    const slides =
      selectedSerialProduct.value?.variants.map((skuId, index) => {
        const base = product.WATCH.find(p => p.skuId === skuId)!
        const extd = all.find(p => p.skuId === skuId)!
        const pdpTitles: string[] = parseJSON(extd?.pdpTitle, [])

        return {
          ...base,
          materialIcon: selectedSerialProduct.value?.materialIcons[index],
          price: extd?.price || 0,
          titleString: extd?.title,
          title: pdpTitles.map(text => ({
            text,
            isAsciiOrExtended: isAsciiOrExtended(text)
          }))
        }
      }) || []

    return slides
  })

  const isSeriesEntryChanged = ref(false)
  const hasPendingSelectedSerieProduct = ref(false)
  const setSelectedProductOfASerie = (product: FORMATTED_PRODUCT_SERIE) => {
    // console.log(
    //   '[[ Selection ] try to select product of serie ]',
    //   { skuId: product.skuId },
    //   Date.now()
    // )
    if (product?.skuId && product.variants.length) {
      console.log(
        '[[ Selection ] Select ProductOfSerie ]',
        { skuId: product.skuId },
        Date.now()
      )
      hasPendingSelectedSerieProduct.value = true
      if (selectedSerialProduct.value?.skuId != product?.skuId) {
        selectedSerialProduct.value = product

        return (isSeriesEntryChanged.value = true)
      }
    }
    return (isSeriesEntryChanged.value = false)
  }

  const reset = () => {
    // console.log('[[ Selection ] try to reset series store ]', Date.now())
    if (selectedSerialProduct.value !== undefined) {
      console.log(
        '[[ Selection ] Reset SeriesStore / SerialProduct ]',
        Date.now()
      )
      selectedSerialProduct.value = undefined
      hasPendingSelectedSerieProduct.value = false
      return true
    }
    return false
  }

  return {
    isSeriesEntryChanged,
    hasPendingSelectedSerieProduct,
    selectedSerialProduct,
    selectedSerie,
    setSelectedProductOfASerie,
    reset
  }
})
